import React from "react";
import { useSiteSettings } from "../../lib/settings";
import { pickLogo } from "../../lib/logo";

/**
 * Renders the admin-managed logo for a slot (header / footer).
 * `max` caps the height inside compact bars. Renders nothing when no logo is set.
 */
const BrandLogo = ({ place = "header", onDark = false, max, className = "", testId }) => {
  const s = useSiteSettings();
  const { src, filterClass, height } = pickLogo(s, { place, onDark });
  if (!src) return null;
  const h = max ? Math.min(height, max) : height;
  return (
    <img
      src={src}
      alt={s.company_name || "Fırat Construction"}
      draggable={false}
      data-testid={testId || `${place}-logo`}
      style={{ height: h, width: "auto" }}
      className={`object-contain block select-none max-w-[52vw] sm:max-w-none transition-[filter] duration-500 ${filterClass} ${className}`}
    />
  );
};

export default BrandLogo;
